import { render, staticRenderFns } from "./AddedRemovedPageDetails.vue?vue&type=template&id=0b5f0971&scoped=true"
import script from "./AddedRemovedPageDetails.vue?vue&type=script&lang=js"
export * from "./AddedRemovedPageDetails.vue?vue&type=script&lang=js"
import style0 from "./AddedRemovedPageDetails.vue?vue&type=style&index=0&id=0b5f0971&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5f0971",
  null
  
)

export default component.exports